import { inject, Injectable } from '@angular/core';
import { RecordsSearchFacade } from 'src/app/search/state/records-search/records-search.facade';

@Injectable({
  providedIn: 'root',
})
export class RecordsSearchResetResolver {
  private readonly recordsSearch = inject(RecordsSearchFacade);

  resolve() {
    return this.recordsSearch.resetStore();
  }
}
